var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exploitable-table-cell",on:{"click":() => { _vm.$emit("click") }}},[(!_vm.item[_vm.category.field])?_c('div',{staticClass:"not-exploitable"},[_vm._v(" "+_vm._s(_vm.exploitedValue)+" ")]):_c('div',{staticClass:"exploitable"},[_c('span',{staticClass:"exploitable-value"},[_vm._v(" "+_vm._s(_vm.exploitedValue)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }